import { Encoder, MGPOptional, MGPUniqueList, Utils } from '@everyboard/lib';
import { Coord } from '../../../jscaip/Coord';
import { Move } from '../../../jscaip/Move';
export class CheckersMove extends Move {
    coords;
    isStep;
    static of(coords, isStep) {
        return new CheckersMove(coords, isStep);
    }
    static fromCapture(coords) {
        return new CheckersMove(coords, false);
    }
    static fromStep(start, end) {
        return new CheckersMove([start, end], true);
    }
    static encoder = Encoder.tuple([Encoder.list(Coord.encoder), Encoder.identity()], (move) => [[...move.coords], move.isStep], (fields) => CheckersMove.of(fields[0], fields[1]));
    constructor(coords, isStep) {
        super();
        this.coords = coords;
        this.isStep = isStep;
    }
    toString() {
        const coordStrings = this.coords.map((coord) => coord.toString());
        const coordString = coordStrings.join(', ');
        if (this.isStep) {
            return 'CheckersStep(' + coordString + ')';
        }
        else {
            return 'CheckersCapture(' + coordString + ')';
        }
    }
    getRelation(other) {
        return CheckersMove.getRelation(this.coords, other.coords);
    }
    static getRelation(a, b) {
        const thisLength = a.length;
        const otherLength = b.length;
        if (thisLength > otherLength) {
            return 'INEQUALITY';
        }
        const minimalLength = Math.min(thisLength, otherLength);
        for (let i = 0; i < minimalLength; i++) {
            if (a[i].equals(b[i]) === false)
                return 'INEQUALITY';
        }
        if (thisLength === otherLength)
            return 'EQUALITY';
        else
            return 'PREFIX';
    }
    equals(other) {
        return this.getRelation(other) === 'EQUALITY';
    }
    // If one of the two is prefix to the other ?
    isPrefix(other) {
        return this.getRelation(other) === 'PREFIX';
    }
    getStartingCoord() {
        return this.coords[0];
    }
    getEndingCoord() {
        return this.coords[this.coords.length - 1];
    }
    getSteppedOverCoordsWithDuplicates() {
        let lastCoordOpt = MGPOptional.empty();
        const allJumpedOverCoords = [];
        for (const coord of this.coords) {
            if (lastCoordOpt.isPresent()) {
                const lastCoord = lastCoordOpt.get();
                const subJumpedOverCoords = lastCoord.getCoordsToward(coord);
                for (const jumpedOverCoord of subJumpedOverCoords) {
                    allJumpedOverCoords.push(jumpedOverCoord);
                }
            }
            allJumpedOverCoords.push(coord);
            lastCoordOpt = MGPOptional.of(coord);
        }
        return allJumpedOverCoords;
    }
    getSteppedOverCoords() {
        return new MGPUniqueList(this.getSteppedOverCoordsWithDuplicates());
    }
    concatenate(move) {
        const lastLandingOfFirstMove = this.getEndingCoord();
        const startOfSecondMove = move.coords[0];
        Utils.assert(lastLandingOfFirstMove.equals(startOfSecondMove), 'should not concatenate non-touching move');
        const firstPart = [...this.coords];
        const secondPart = [...move.coords].slice(1);
        return CheckersMove.fromCapture(firstPart.concat(secondPart));
    }
}
